import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Paperclip: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5326 7.59329L8.31704 13.8611C8.07588 14.1068 7.78814 14.302 7.47067 14.4352C7.1532 14.5685 6.81235 14.6371 6.46805 14.6371C6.12373 14.6371 5.78289 14.5685 5.46541 14.4352C5.14794 14.302 4.86021 14.1068 4.61905 13.8611L2.7596 11.9703C2.27283 11.4759 2 10.8099 2 10.1161C2 9.42226 2.27283 8.75626 2.7596 8.26186L9.38257 1.618C9.57679 1.42218 9.80787 1.26675 10.0625 1.16068C10.3171 1.05461 10.5901 1 10.8659 1C11.1417 1 11.4148 1.05461 11.6694 1.16068C11.924 1.26675 12.1551 1.42218 12.3493 1.618L13.091 2.35969C13.2869 2.55391 13.4423 2.78499 13.5483 3.03958C13.6544 3.29417 13.709 3.56726 13.709 3.84306C13.709 4.11887 13.6544 4.39195 13.5483 4.64655C13.4423 4.90115 13.2869 5.13222 13.091 5.32644L7.22018 11.2181C7.12306 11.3161 7.00753 11.3938 6.88023 11.4468C6.75294 11.4999 6.61639 11.5271 6.47849 11.5271C6.34059 11.5271 6.20405 11.4999 6.07674 11.4468C5.94945 11.3938 5.83391 11.3161 5.7368 11.2181L5.37118 10.8421C5.27326 10.745 5.19555 10.6294 5.14252 10.5021C5.08949 10.3749 5.06218 10.2383 5.06218 10.1004C5.06218 9.9625 5.08949 9.82596 5.14252 9.69866C5.19555 9.57137 5.27326 9.45583 5.37118 9.35872L9.30944 5.45179"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
